import React, { useEffect, useState } from "react";
import { ConnectedProps } from "react-redux";
import { Table, Typography } from "antd";

import { NavigationPath, ROLES, history } from "../../utils";
import ActionButtons from "../ActionButtons/ActionButtons";
import { OfferRequestsTableType } from "../../models";
import { offerRequestsColumns } from "../../utils/";
import connector from "./Container";

const OfferRequests = ({
  state,
  actions,
}: ConnectedProps<typeof connector>) => {
  const { offerRequests, loggedUser } = state;

  const [selected, setSelected] = useState<OfferRequestsTableType[] | null>(
    null
  );

  useEffect(() => {
    actions.getOfferRequests();
  }, []);

  const rowSelection = {
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: OfferRequestsTableType[]
    ) => {
      setSelected(selectedRows);
    },
  };

  const navigateToAddOfferRequest = () => {
    history.navigate(NavigationPath.ADD_OFFER_REQUEST_ROUTE);
  };

  const navigateToEdit = () => {
    if (!selected) {
      return;
    }
    history.navigate(`/edit-offer-request/${selected[0].key}`);
  };

  const handleDeleteOfferRequest = () => {
    if (selected) {
      const offerRequestIds = selected.map(
        (offerRequest: OfferRequestsTableType) => offerRequest.key
      );
      actions.deleteOfferRequest(offerRequestIds);
      setSelected(null);
    }
  };

  return (
    <>
      <div className="px-8 py-4">
        <Typography className="text-xl font-bold text-secondary py-1">
          ZAHTJEVI ZA PONUDE
        </Typography>
      </div>
      <div className="h-5 bg-base-gray"></div>

      <div className="px-8 py-4">
        <div className="mb-4">
          <ActionButtons
            navigateToAdd={navigateToAddOfferRequest}
            navigateToEdit={
              loggedUser?.role === ROLES.S_PREMIUM_ADMIN
                ? navigateToEdit
                : undefined
            }
            handleDelete={handleDeleteOfferRequest}
            selected={selected}
          />
        </div>
        <Table
          columns={offerRequestsColumns()}
          dataSource={offerRequests}
          rowSelection={{
            ...rowSelection,
          }}
        />
      </div>
    </>
  );
};

export default OfferRequests;
